import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "hotel-facilities-teaser" }
const _hoisted_2 = { class: "hotel-facilities-teaser__list" }

import InfoIconHeader from '@lmt-rpb/Molecules/HotelFacilitiesTeaser/internals/IconInfoHeader.vue';
import { computed } from 'vue';
import BaseModal from '@lmt-rpb/BaseModal/BaseModal.vue';
import type { IconNames } from '@lmt-rpb/BaseIcon/svg';
import type { Attribute } from '@/interfaces/offer-list-types/offer-list-typo-hotel-data';
import { getHotelFacilityIcon } from './helpers';
import HotelFacilitiesGrid from './internals/HotelFacilitiesGrid.vue';

interface Props {
	attributes: Attribute[];
	topSeller?: boolean;
	rooms?: number;
	buttonLabel?: string;
	modalTitle?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HotelFacilitiesTeaser',
  props: {
    attributes: {},
    topSeller: { type: Boolean, default: false },
    rooms: { default: undefined },
    buttonLabel: { default: 'Komplette Ausstattung' },
    modalTitle: { default: 'Ausstattung' }
  },
  emits: ['show-more-click'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const mergedFacilities = computed(() => {
	const _mergedFacilities: { Name: string; icon: IconNames }[] = [];
	if (props.topSeller) {
		_mergedFacilities.push({ Name: 'Top Seller', icon: 'topSeller' });
	}
	if (props.rooms) {
		_mergedFacilities.push({ Name: `${props.rooms} Zimmer`, icon: 'rooms' });
	}
	return [
		..._mergedFacilities,
		...props.attributes.map((attribute) => ({ Name: attribute.Attributes[0].Name, icon: getHotelFacilityIcon(attribute.Name) })),
	];
});

const onShowMoreClick = () => {
	emit('show-more-click');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mergedFacilities.value, (facility) => {
        return (_openBlock(), _createBlock(InfoIconHeader, {
          key: facility.Name,
          class: "hotel-facilities-teaser__list-item",
          icon: facility.icon,
          title: facility.Name,
          size: "small"
        }, null, 8 /* PROPS */, ["icon", "title"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createVNode(BaseModal, {
      "header-title": _ctx.modalTitle,
      class: "hotel-facilities-teaser__modal",
      "with-open-button": "",
      "open-button-props": { label: _ctx.buttonLabel, class: 'hotel-facilities-teaser__show-more' },
      onOpen: onShowMoreClick
    }, {
      default: _withCtx(() => [
        _createVNode(HotelFacilitiesGrid, { attributes: _ctx.attributes }, null, 8 /* PROPS */, ["attributes"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["header-title", "open-button-props"])
  ]))
}
}

})